import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;

  select {
    width: 100%;
    min-width: 0;
    height: 36px;
    padding: 0 34px 0 16px;
    border-radius: 999px;
    border: 1px solid #d9d9d9;
    background-color: #fff;
    font-size: 13px;
    font-weight: 600;
    color: #262626;
    cursor: pointer;
  }

  @media (min-width: 769px) {
    width: auto;

    select {
      width: auto;
      min-width: 160px;
    }
  }
`;
